// frontend/src/components/LLMInsightCard.js
import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import InsightsIcon from '@mui/icons-material/Insights';
import { useTheme } from '@mui/material/styles';

export default function LLMInsightCard({ insight, loading }) {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography 
            component="h2" 
            variant="h6" 
            sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <InsightsIcon style={{ color: theme.palette.primary.main }} />
          Automated summary
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50px' }}>
            <CircularProgress size={24} />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
              Generating real-time analysis...
            </Typography>
          </Box>
        ) : (
          <Alert severity="info" sx={{ '& .MuiAlert-message': { width: '100%' } }}>
            {insight || "No summary available at the moment."}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}